import useAuth from '../../_shared/hooks/useAuth';
import { AuthKey, OnlineAuthUser } from '../../_shared/types/auth.types';

export const { getUser, isAuthenticated, setUser } = useAuth<OnlineAuthUser>(
  AuthKey.Online
);
